.root {
  --header-button-hover: var(--mantine-color-gray-3);
  --button-hover: var(--header-button-hover) !important;
  --ai-hover: var(--header-button-hover) !important;

  height: 30px !important;
  color: var(--mantine-color-text) !important;

  &[aria-current="page"],
  &[data-expanded="true"],
  &[aria-expanded="true"] {
    background-color: var(--header-button-hover) !important;
  }
}

[data-mantine-color-scheme="dark"] .root {
  --header-button-hover: var(--mantine-color-gray-7);
}
